export default {
  "home.hero.title": "发现无限精彩，记录美好生活",
  "home.hero.subtitle": "快猫视频，汇聚海量优质短视频内容，一键录制、智能剪辑、轻松发布，让你的创意闪耀世界。",
  "home.hero.cta": "立即加入",
  "home.hero.download": "下载APP",
  "home.hotVideos": "热门视频",
  "home.hotVideos.desc": "精选全网最热门短视频内容，让你不错过每一个精彩瞬间",
  "home.categories": "热门分类",
  "home.categories.desc": "多种内容分类，发现你感兴趣的精彩视频",
  "home.creators": "创作达人",
  "home.creators.desc": "加入百万创作者社区，展示你的才华",
  "home.download.title": "随时随地，记录精彩",
  "home.download.subtitle": "下载快猫视频APP，开启你的创作之旅",
  "home.download.ios": "iOS 下载",
  "home.download.android": "Android 下载",
  "home.stats.users": "活跃用户",
  "home.stats.videos": "视频总量",
  "home.stats.creators": "创作者",
  "home.stats.downloads": "下载量",
};